import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import * as TTnaUpdateActions from './tna-updates.actions';
import * as TTnaUpdateSelectors from './tna-updates.selectors';
import {
  TREQUEST_BULK_COMPLETE_TNA_ORDER_STEPS,
  TREQUEST_GET_TNA_ORDER_STEP_LIST,
  TREQUEST_UPDATE_TNA_STEP,
  TRESPONSE_GET_TNA_ORDER_STEP_LIST,
  TTnaOrderStepFetchReason,
  TUserPaginationOption,
} from '@monorepo/types';

export const TNA_UPDATES_ITEMS_PER_PAGE_LIST = [10, 50, 100, 200];

@Injectable({
  providedIn: 'root',
})
export class TnaUpdateFacade {
  constructor(private store: Store<TPlani8State>) {}

  fetchTnaStepsList(payload: TREQUEST_GET_TNA_ORDER_STEP_LIST, fetchReason: TTnaOrderStepFetchReason) {
    this.store.dispatch(new TTnaUpdateActions.GetTnaOrderStepList(payload, fetchReason));
  }

  fetchTnaStepDetails(tosId: TRESPONSE_GET_TNA_ORDER_STEP_LIST['tnaOrderStepItemList'][number]['tosId']) {
    this.store.dispatch(new TTnaUpdateActions.GetTnaOrderStep(tosId));
  }

  updateTnaStep(
    payload: TREQUEST_UPDATE_TNA_STEP,
    status: TREQUEST_GET_TNA_ORDER_STEP_LIST['status'],
    listingPayload: TREQUEST_GET_TNA_ORDER_STEP_LIST,
  ) {
    this.store.dispatch(new TTnaUpdateActions.UpdateTnaOrderStep(payload, status, listingPayload));
  }

  bulkCompleteTnaOrderSteps(
    payload: TREQUEST_BULK_COMPLETE_TNA_ORDER_STEPS,
    listingPayload: TREQUEST_GET_TNA_ORDER_STEP_LIST,
  ) {
    this.store.dispatch(new TTnaUpdateActions.BulkCompleteTnaOrderSteps(payload, listingPayload));
  }

  getTnaStepsList() {
    return this.store.pipe(select(TTnaUpdateSelectors.getTnaStepsList));
  }

  getTnaStepDetails() {
    return this.store.pipe(select(TTnaUpdateSelectors.getTnaStepDetails));
  }

  getUserPaginationOption() {
    return this.store.pipe(select(TTnaUpdateSelectors.getUserPaginationOption));
  }

  setUserPaginationOption(option: TUserPaginationOption) {
    return this.store.dispatch(new TTnaUpdateActions.SetUserPaginationOption(option));
  }
}

export type TGetTnaStepsList = ReturnType<TnaUpdateFacade['getTnaStepsList']>;
export type TGetTnaStepDetails = ReturnType<TnaUpdateFacade['getTnaStepDetails']>;
